import React from 'react';
import AuthStorage from '~/Utils/AuthStorage';
import { CARACTERISTICA_VALIDADOR_ASSINATURA_DIGITAL } from '~/constant';
import empreendimento from '~/Images/empreendimentos.svg';
import prospecto from '~/Images/prospecto.svg';
import sismac from '~/Images/sismac.svg';
import speedometer from '~/Images/produtividade.svg';
import handingMoney from '~/Images/estorno.svg';
import declined from '~/Images/declined.svg';
import transfer from '~/Images/transfer.svg';
import sistema from '~/Images/sistema.svg';
import vendas from '~/Images/vendas.svg';
import proposalAccept from '~/Images/proposal-accept.svg';
import proposalReject from '~/Images/proposal-reject.svg';
import proposalCancel from '~/Images/proposal-cancel.svg';
import megaphone from '~/Images/megaphone.svg';
import {
  FaUsers,
  FaBuilding,
  FaSitemap,
  FaDollarSign,
  FaBarcode,
  FaCog,
  FaEnvelope,
  FaDesktop,
  FaCogs,
  FaThList,
  FaChartBar,
  FaGlobe,
  FaFilePdf,
  FaInfoCircle,
  FaUser,
  FaRocket,
  FaChartPie,
  FaEdit,
  FaMarker,
  FaGavel,
  FaSearchDollar,
  FaCalendarTimes,
  FaHourglassEnd,
  FaMoneyBill,
  FaHouseDamage,
  FaThLarge,
  FaSearch,
  FaExchangeAlt,
  FaKey,
  FaHistory,
  FaLock,
  FaQuestionCircle,
  FaUserTie,
  FaClipboardList,
  FaComments,
  FaListAlt,
  FaHandshake,
  FaCalendarAlt,
  FaCalculator,
  FaTicketAlt,
  FaStar,
  FaCubes,
  FaFileExcel,
  FaFileAlt,
  FaFileInvoiceDollar,
  FaBriefcase,
  FaMapMarkedAlt,
  FaPercentage,
  FaRoute,
  FaCoins,
  FaFileUpload,
  FaCreditCard,
  FaBell,
  FaBalanceScaleLeft, 
  FaSms,
  FaUniversity,
  FaBalanceScale,
} from 'react-icons/fa';
import {
  caracteristicas,
  EMPREENDIMENTO_LANCAMENTO,
  COBRANCA_IMOVEL,
  CARACTERISTICA_RASTREAMENTO_TITULOS,
  CARACTERISTICA_MANUTENCAO_TITULO,
  CARACTERISTICA_CONSULTA_CGC_CPF,
  CADASTRO_CARTAO_TAXA,
  ROUTE_EXP_IMP_COTACAO_MOEDA_FORTE,
  CARACT_EXP_IMP_COTACAO_MOEDA_FORTE,
  ROUTE_ALTERA_NOME_ATIVO,
  TIPO_ATENDIMENTO_CARACTERISTICA,
  GESTAO_IPTU,
  CARACTERISTICA_RETORNO_BRADESCO,
  RETORNO_COBRANCA_BRADESCO,
  CARACTERISTICA_CONTROLE_HORAS_PJ,
  RETORNO_COBRANCA_GERAL,
  ROUTE_MANUAL_APURACAO,
  CARACTERISTICA_HOMOLOGADOR,
  CARACTERISTICA_POSICAO_SINTETICA_CARTEIRA_RECEBER,
  CARACTERISTICA_RATEIO_TEMPLATE,
  CARACTERISTICA_RELAT_COMISSAO_IMOVEIS,
  CARACTERISTICAS_APROVACAO_DESPESA,
  ROUTE_AUTORIZA_DESPESA,
  CARACTERISTICA_CANCELA_PROPOSTA_MISTA,
  ROUTE_CONSULTA_ANIVERSARIANTES,
  CARACTERISTICA_CONSULTA_ANIVERSARIANTES,
  CARACTERISTICA_RELATORIO_RAZAO_SOCIAL,
  ROUTE_RELATORIO_RAZAO_SOCIAL,
  CARACTERISTICA_PORTADOR_JURIDICO,
  ROUTE_PORTADOR_JURIDICO,
  CARACTERISTICA_COBRADOR_GERENCIAL,
  CARACTERISTICA_COBRADOR_OPERACIONAL,
  ROUTE_TRANSF_COBRANCA,
  CARACTERISTICA_BAIXA_TITULO,
  CARACTERISTICA_ACERTAR_CONTA,
  ROUTE_ACERTAR_CONTA,
  CARACTERISTICA_ALTERAR_CODIGO_CONTA,
  ROUTE_ALTERAR_CODIGO_CONTA,
  CARACTERISTICA_ALTERAR_CODIGO_DEPARTAMENTO,
  ROUTE_ALTERAR_CODIGO_DEPARTAMENTO,
  ROUTE_CONSULTA_OCORRENCIAS_ATIVO,
  CARAC_REAPRESENTAR_CHEQUES,
  CARACTERISTICA_TRANSFERENCIA_OCORRENCIAS,
  ROUTE_TRANSFERENCIA_OCORRENCIAS,
  CARACTERISTICA_CONCILIACAO_BANCARIA,
  ROUTE_CONCILIACAO_BANCARIA,
  CARACTERISTICA_MONITORAMENTO,
  CARACTERISTICA_ESTORNO_TITULO,
  ROUTE_ESTORNO_BAIXA_TITULO,
  CARACTERISTICA_FECHA_CAIXA,
  ROUTE_FECHAMENTO_CAIXA,
  MENU_GERENCIA_EMAIL,
  CARACTERISTICA_ATA_CONTABIL,
  CARACTERISTICA_RELATORIO_REMESSA_BOLETOS,
  ROUTE_RELATORIO_REMESSA_BOLETOS,
  ROUTE_CONTAS_PREFEITURA_SEM_CONVENIO,
  ROUTE_PARAMETROS_SISTEMA_FUSAO,
  CARACTERISTICA_CONTATOS_TESTE,
  ROUTE_PARAMETROS_CONTATOS_TESTE,
  CARACTERISTICA_LOCAL_ATENDIMENTO,
  CARACTERISTICA_ACESSO_JURIS,
  ROUTE_CONTAS_ISENTAS_JURIDICO,
  CARACTERISTICA_AUDITORIA,
  ROUTE_CHEQUES_PRORROGADOS,
  ROUTE_HISTORICO_IMOVEIS,
  CARACTERISTICA_RELAT_CONTAS_SEM_SALDO_CONF,
  CARACTERISTICA_ATUALIZA_TAXA_TRANSFERENCIA,
  CARACTERISTICA_GENERATE_MANUTENCAO,
  ROUTE_RELACIONAMENTO_CONTAS,
  ROUTE_LISTA_EMAIL_CLIENTES,
  CARAC_COMUNICADO_EMAIL,
  CARACTERISTICA_EVENTO_RSVP,
  CARACTERISTICA_CHECKIN_PESQUISA_EVENTO,
  ROUTE_EVENTOS_RSVP,
  ROUTE_EVENTO_RSVP_CHECKIN,
  ROUTE_PESQUISA_EVENTO,
  CARACTERISTICA_CARTAO_CREDITO,
  CARACTERISTICA_IMPLANTA_REEMBOLSAVEIS,
  ROUTE_COTACOES_MOEDA_FORTE,
  CHAR_SALDO_CONTAS_CONFERIR,
  ROUTE_SALDOS_CONTAS,
  CARACTERISTICA_CONTAS_DIF_LIQ,
  ROUTE_CONTAS_DIF_LIQ,
  CARACTERISTICA_IMPORTACAO_XLS_CONTAS,
  ROUTE_RELATORIO_PLANO_CONTAS,
  RBAC_RESULTADO_ATENDIMENTO,
  ROUTE_RESULTADO_ATENDIMENTO,
  ROUTE_HISTORICO_PADRAO,
  ROUTE_IMOVEIS_ESTOQUE,
  CARACTERISTICA_RELATORIO_CONTAS,
  ROUTE_ETIQUETAS_CARTAS,
} from '~/constant';
import { FcBullish } from 'react-icons/fc';
import { gerarAmbienteUrl, isAmbienteProducao } from '~/Pages/Vendas/helpers';

export const URLV1 = `${gerarAmbienteUrl(true)}`;
export const URLV2 = `${gerarAmbienteUrl(false)}`;
const isADM = AuthStorage.isADM();
const isCorretor = AuthStorage.isCorretor();

const links = [
  {
    icon: <FaRocket />,
    label: 'Menu de Lançamento de Vendas',
    dropdown: [
      {
        header: 'Proposta',
      },
      {
        href: '/prospectos/lista',
        icon: <img src={prospecto} alt="Prospectos" />,
        label: 'Prospectos',
      },
      {
        divider: true,
      },
      {
        header: 'Atendimento',
      },
      {
        href: `/lancamento/colaborador/atendimento`,
        icon: <FaDesktop />,
        label: 'Iniciar / Encerrar Atendimento',
      },
      {
        href: '/atendimento/consulta-cpf',
        icon: <FaSearch />,
        label: 'Consulta CPF',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },

      {
        divider: true,
      },
      {
        header: 'Mapa/Espelho',
      },
      {
        href: '/mapa',
        icon: (
          <img
            className="invert-color"
            src={empreendimento}
            alt="Mapa de empreendimentos"
          />
        ),
        label: 'Mapa do empreendimento',
      },
      {
        divider: true,
      },
      {
        header: 'Adm. Vendas',
      },
      {
        href: '/AdministracaoVendas',
        icon: <FaChartBar />,
        label: 'Administração de vendas',
      },
    ],
    visible: () => {
      return (
        AuthStorage &&
        AuthStorage.isAtendenteLancamento() &&
        !AuthStorage.temCaracteristica(584)
      );
    },
  },
  {
    icon: <FaUsers />,
    label: 'Prospectos',
    dropdown: [
      {
        href: isADM || isCorretor ? '/prospectos/lista' : '/prospectos',
        icon: <img src={prospecto} alt="Prospectos" />,
        label: (
          <>
            Prospectos <span className="badge badge-primary">novo</span>
          </>
        ),
      },
      {
        href: '/atribuir/prospecto',
        icon: <img src={transfer} alt="Atribuir prospecto" />,
        label: 'Atribuir Prospecto',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristicas([201, 199], [495]) &&
            !AuthStorage.isAtendenteLancamento()
          );
        },
      },
      {
        href: '/prospecto/gerenciamento-massa',
        icon: <FaEdit />,
        label: <>Gerenciar em Massa</>,
      },
      {
        href: '/lancamento/cadastro-rapido',
        icon: <FaTicketAlt />,
        label: 'Vincular Senha',
      },
    ],
    visible: () => {
      return (
        AuthStorage &&
        AuthStorage.temCaracteristicas(
          [],
          [501, CARACTERISTICA_CHECKIN_PESQUISA_EVENTO]
        ) &&
        !AuthStorage.isAtendenteLancamento()
      );
    },
  },
  {
    icon: <img src={empreendimento} alt="Empreendimentos" />,
    label: 'Empreendimentos',
    dropdown: [
      { header: 'Mapa' },
      {
        href: '/mapa',
        icon: (
          <img
            className="invert-color"
            src={empreendimento}
            alt="Mapa humanizado"
          />
        ),
        label: 'Mapa Humanizado',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([200, 201, 277], [224]);
        },
      },
      {
        href: `/mapa-empreendimento`,
        icon: (
          <img
            className="invert-color"
            src={empreendimento}
            alt="Mapa quadriculado do empreendimento"
          />
        ),
        label: 'Mapa do Empreendimento',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([200, 201, 277]);
        },
      },
      {
        href: '/comercial/consulta-imoveis',
        icon: <FaSearch />,
        label: 'Consulta Imóveis',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP);
        },
      },
      // {
      //   href: `${URLV1}/PDV/MapaEmpreendimento.aspx`,
      //   icon: (
      //     <img
      //       className="invert-color"
      //       src={empreendimento}
      //       alt="Mapa de empreendimentos"
      //     />
      //   ),
      //   label: 'Mapa de empreendimentos',
      //   visible: () => {
      //     return !AuthStorage
      //       ? false
      //       : AuthStorage.temCaracteristicas([200, 201, 277], [224]);
      //   },
      // },
      // {
      //   href: `${URLV1}/PDV/MapaEmpreendimento.aspx`,
      //   icon: (
      //     <img
      //       className="invert-color"
      //       src={empreendimento}
      //       alt="Mapa de empreendimentos"
      //     />
      //   ),
      //   label: 'Mapa de empreendimentos',
      // },
      // {
      //   href: `${URLV1}/Empreendimento/ImoveisDisponiveis.aspx`,
      //   icon: <FaBuilding />,
      //   label: 'Estoque disponível',
      //   visible: () => {
      //     return !AuthStorage
      //       ? false
      //       : AuthStorage.temCaracteristicas([200, 201, 277]);
      //   },
      // },
      // {
      //   href: `/comercial/hierarquia`,
      //   icon: <FaSitemap />,
      //   label: 'Hierarquia comercial',
      //   visible: () => {
      //     return !AuthStorage
      //       ? false
      //       : AuthStorage.temCaracteristicas([199], [495]);
      //   },
      // },

      { divider: true },
      { header: 'Configuração' },
      {
        href: '/comercial/empreendimento',
        icon: <FaBuilding />,
        label: 'Empreendimento',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
                AuthStorage.temCaracteristicas([129]);
        },
      },
      { divider: true },
      { header: 'Preços e Ativos' },
      {
        href: `/tabela-precos`,
        icon: <FaThList />,
        label: 'Tabelas de preços',
      },
      {
        href: '/comercial/tabela-precos',
        icon: <FaThList />,
        label: 'Tabela de Preços (Nova)',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([617]);
        },
      },
      {
        href: '/comercial/qualidade-ativo',
        icon: <FcBullish />,
        label: 'Qualidade do Ativo',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.temCaracteristicas([617]);
        },
      },
      {
        href: '/ativo/importacao-xls',
        icon: <FaFileExcel />,
        label: 'Importação XLS Ativos',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
                AuthStorage.temCaracteristicas([35]);
        },
      },
      {
        href: '/cadastro/ajustar-dados-imoveis',
        icon: <FaEdit />,
        label: 'Ajustar Dados de Imóveis',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
                AuthStorage.temCaracteristicas([caracteristicas.AtualizaAtivo]);
        },
      },
      {
        href: `/precificacao-ativos`,
        icon: <FaMoneyBill />,
        label: 'Precificação de Ativos',
        visible: () => {
          return !AuthStorage ? false : AuthStorage.isADM();
        },
      },
      {
        href: '/ativos',
        icon: <FaThList />,
        label: 'Manutenção de Ativos',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
                AuthStorage.temCaracteristicas([35]);
        },
      },
      {
        href: '/imobilizado/lancar-compra',
        icon: <FaMoneyBill />,
        label: 'Lançamento de Compra — Imobilizado',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
                AuthStorage.temCaracteristicas([93]);
        },
      },
      {
        href: '/ativo/grupo-familias',
        icon: <FaThList />,
        label: 'Grupo de Famílias',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
                AuthStorage.temCaracteristicas([35]);
        },
      },
      {
        href: '/ativo/familias-ativos',
        icon: <FaThList />,
        label: 'Famílias de Ativos',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
                AuthStorage.temCaracteristicas([35]);
        },
      },
      {
        href: '/ativo/qualidades',
        icon: <FaStar />,
        label: 'Qualidades de Ativos',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
                AuthStorage.temCaracteristicas([35]);
        },
      },
      {
        href: '/ativo/variantes',
        icon: <FaCubes />,
        label: 'Variantes de Ativos',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
                AuthStorage.temCaracteristicas([35]);
        },
      },
      {
        href: '/gestao-iptu',
        icon: <FaListAlt />,
        label: 'Gestão IPTU',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(GESTAO_IPTU);
        },
      },
      { divider: true },
      { header: 'Estoque' },
      {
        href: `/casas-disponiveis`,
        icon: <FaHouseDamage />,
        label: 'Casas Disponíveis',
        visible: () => {
          return true;
        },
      },
      {
        href: `/imoveis-disponiveis`,
        icon: <FaThLarge />,
        label: 'Imóveis Disponíveis',
        visible: () => {
          return true;
        },
      },
      {
        href: '/atendimento/ocorrencias-imoveis',
        icon: <FaBuilding />,
        label: 'Ocorrências Imóveis',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP);
        },
      },
      {
        href: '/consulta/ocorrencias-contas',
        icon: <FaListAlt />,
        label: 'Ocorrências de Contas',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.isADM();
        },
      },
      { divider: true },
      { header: 'Documentação' },
      {
        href: `/empreendimentos/base-conhecimento`,
        icon: <FaFilePdf />,
        label: 'Base de Conhecimento',
        visible: () => {
          return true;
        },
      },
      { divider: true },
      { header: 'Atendimento' },
      {
        href: '/atendimento/comunicado-quitacao',
        icon: <FaEnvelope />,
        label: 'Comunicado de Quitação',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.temCaracteristicas([
                  caracteristicas.ListaComunicadoQuitacao,
                ]);
        },
      },
      {
        href: '/imob/local-atendimento',
        icon: <FaMapMarkedAlt />,
        label: 'Local de Atendimento',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([CARACTERISTICA_LOCAL_ATENDIMENTO]),
      },
      { header: 'Administração' },
      {
        href: '/imob/reembolso-iptu',
        icon: <FaMoneyBill />,
        label: 'Solicita reembolso clientes',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(
            CARACTERISTICA_IMPLANTA_REEMBOLSAVEIS
          ) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      {
        href: '/imob/alertas-empreendimento',
        icon: <FaBell />,
        label: 'Alertas de Empreendimentos',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      {
        href: '/empreendimentos/restringir-acesso',
        icon: <FaLock />,
        label: 'Restringir Acesso',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(
                caracteristicas.RestringeEmpreendimentos
              ) && AuthStorage.temCaracteristica(caracteristicas.MigracaoERP);
        },
      },
      {
        // W-0691 — Char 670 (CARACTERISTICA_ATUALIZA_TAXA_TRANSFERENCIA, corrigido de 695) + char 630
        // (caracteristicas.MigracaoERP) são portões obrigatórios durante HML — manter no OR menu+rota
        // até promoção HML→DONE. BE checa AND [630, 670] em EmpreendimentoController.taxa-transferencia/lote (PRs #763 + #772).
        href: '/administracao/atualiza-taxa-transferencia',
        icon: <FaExchangeAlt />,
        label: 'Atualiza Taxa de Transferência',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
              AuthStorage.temCaracteristica(
                CARACTERISTICA_ATUALIZA_TAXA_TRANSFERENCIA
              ),
      },
      { header: 'Atendimento' },
      {
        href: '/atendimento/comunicado-quitacao',
        icon: <FaEnvelope />,
        label: 'Comunicado de Quitação',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(
                caracteristicas.ListaComunicadoQuitacao
              ) && AuthStorage.temCaracteristica(caracteristicas.MigracaoERP);
        },
      },
      {
        href: ROUTE_CONTAS_ISENTAS_JURIDICO,
        icon: <FaGavel />,
        label: 'Contas Isentas Jurídico',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.temCaracteristica(CARACTERISTICA_ACESSO_JURIS);
        },
      },
      { divider: true },
      { header: 'Jurídico' },
      {
        href: ROUTE_PORTADOR_JURIDICO,
        icon: <FaGavel />,
        label: 'Portador Jurídico',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.temCaracteristica(CARACTERISTICA_PORTADOR_JURIDICO);
        },
      },
      {
        href: ROUTE_CONTAS_ISENTAS_JURIDICO,
        icon: <FaGavel />,
        label: 'Contas Isentas Jurídico',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.temCaracteristica(CARACTERISTICA_ACESSO_JURIS);
        },
      },
      { divider: true },
      { header: 'Relatórios Imob' },
      {
        // W-0759 — Imóveis em Estoque (Relatório Comercial Imob).
        // VALUE-GATE: produção confirmada em 2026-07-27; char funcional 724.
        href: ROUTE_IMOVEIS_ESTOQUE,
        icon: <FaChartBar />,
        label: 'Imóveis em Estoque',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.ImoveisEstoque),
      },
      {
        href: '/imob/relatorios/imoveis-vendidos',
        icon: <FaChartBar />,
        label: 'Imóveis Vendidos',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        // W-0753 — Ficha de Empreendimento (ADR-001 — isAdm via claim JWT)
        href: '/relatorios/imob/ficha-empreendimento',
        icon: <FaFileAlt />,
        label: 'Ficha de Empreendimento',
        visible: () => !!AuthStorage && AuthStorage.isAdm(),
      },
      {
        // W-0750 — Etiquetas Imóveis (Imob > Relatórios > Administração). Read-only.
        // Gate char 630 (MigracaoERP — portão de migração HML, não é RBAC).
        href: '/relatorios/administracao/etiquetas-imoveis',
        icon: <FaFileAlt />,
        label: 'Etiquetas Imóveis',
        visible: () => AuthStorage && AuthStorage.temCaracteristicas([630]),
      },
      {
        // W-0743 — Imob > Relatórios > Administração > Atualização Cadastral Prefeitura/Água.
        // VALUE-GATE: produção confirmada em 2026-07-27; mantém char funcional 236.
        href: '/relatorios/atualizacao-cadastral',
        icon: <FaFileAlt />,
        label: 'Atualização Cadastral Pref./Água',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(236),
      },
      {
        // W-0777 — Estoque Disponível Imob (Contábil) — char 630 (CARACTERISTICA_HOMOLOGADOR)
        // = portão de migração; remover na promoção HML→DONE. Sem RBAC funcional próprio.
        href: '/imob/relatorio/estoque-contabil',
        icon: <FaListAlt />,
        label: 'Estoque Disponível',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      {
        // W-0779 — Relatório Razão Social (Contábil). RBAC característica 694
        // (Q-01=A — dados sensíveis CNPJ/sócios/capital).
        href: ROUTE_RELATORIO_RAZAO_SOCIAL,
        icon: <FaFileAlt />,
        label: 'Razão Social',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_RELATORIO_RAZAO_SOCIAL),
      },
      { divider: true },
      {
        header: 'Cobrança',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        // W-0804 — Acordos de cobrança não concretizados. Char 630 (MigracaoERP) = portão de
        // migração (gate em menu E rota, defesa em profundidade). Escopo de cobrador no backend.
        href: '/relatorios/cobranca/acordos-nao-concretizados',
        icon: <FaSearchDollar />,
        label: 'Acordos de cobrança não concretizados',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        // W-0817 — Conciliação dos Recebimentos. Char 630 = portão de migração HML.
        href: '/relatorios/cobranca/conciliacao-recebimentos',
        icon: <FaFileAlt />,
        label: 'Conciliação dos Recebimentos',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        // W-0477 — Comissão Retida (char 630 portão de migração)
        href: '/relatorios/comissao-retida',
        icon: <FaChartBar />,
        label: 'Comissão Retida',
        visible: () =>
          AuthStorage && AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
    ],
    visible: () => {
      return (
        AuthStorage &&
        AuthStorage.temCaracteristicas(
          [],
          [501, CARACTERISTICA_CHECKIN_PESQUISA_EVENTO]
        ) &&
        !AuthStorage.isAtendenteLancamento() &&
        !AuthStorage.temCaracteristica(584)
      );
    },
  },
  {
    icon: <FaSearchDollar />,
    label: 'Pós-Venda',
    dropdown: [
      {
        href: `/relatorio/solicitacoes-cessoes`,
        icon: <FaExchangeAlt />,
        label: 'Solicitações de Cessões',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.AcessoTelaCessao);
        },
      },
      {
        href: `/autoatendimento/escritura/solicitacoes`,
        icon: <FaFilePdf />,
        label: 'Solicitações de Escritura',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(
                caracteristicas.TelaAutoatendimentoEscritura
              );
        },
      },
      {
        href: '/imob/atendimento/declaracao-quitacao',
        icon: <FaFilePdf />,
        label: 'Declaração de Quitação',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
    ],
    visible: () => {
      return (
        AuthStorage &&
        AuthStorage.temCaracteristicas(
          [],
          [501, CARACTERISTICA_CHECKIN_PESQUISA_EVENTO]
        ) &&
        !AuthStorage.isAtendenteLancamento() &&
        !AuthStorage.temCaracteristica(584)
      );
    },
  },
  {
    icon: <img src={vendas} alt="Vendas" />,
    label: 'Vendas',
    dropdown: [
      { header: 'Gestão' },
      {
        href: '/AdministracaoVendas',
        icon: <FaChartBar />,
        label: 'Administração de vendas',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([200, 201, 277], [224]);
        },
      },
      {
        href: '/autoriza-venda-pendencia-juridica',
        icon: <FaGavel />,
        label: 'Autoriza Venda com Pendência Jurídica',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(
                caracteristicas.AprovaVendaPendenciaJuridica
              ),
      },
      { divider: true },
      { header: 'Ativos' },
      {
        href: '/relatorio-cotacao-moeda-forte',
        icon: <FaFileAlt />,
        label: 'Cotação Moeda Forte',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([48]),
      },
      {
        href: ROUTE_COTACOES_MOEDA_FORTE,
        icon: <FaExchangeAlt />,
        label: 'Manutenção de Cotação Moeda Forte',
        // Acesso só pelo portão de migração 630 (UMoedaForte.pas FormActivate sem RBAC;
        // char 48 'Alterar Cotacao' gateia só o botão Alterar em FormCotacao + BE /alterar).
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      {
        href: '/comercial/consultar-saldos',
        icon: <FaDollarSign />,
        label: 'Consulta de saldo',
      },
      {
        href: '/consulta-cgc-cpf',
        icon: <FaSearch />,
        label: 'Consulta CGC/CPF',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_CONSULTA_CGC_CPF) &&
                AuthStorage.temCaracteristica(caracteristicas.MigracaoERP);
        },
      },
      {
        href: ROUTE_CONSULTA_OCORRENCIAS_ATIVO,
        icon: <FaListAlt />,
        label: 'Ocorrências de Ativos',
        // Paridade Delphi: tela aberta a qualquer usuario (ProjetoMAIN.PAS:4685
        // nao chama AutorizaUsuario). Char 630 (HOMOLOGADOR) eh apenas gate de
        // migracao HML — removido na promocao HML→DONE.
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      { divider: true },
      { header: 'Comercial' },
      {
        href: '/comercial/redutores-desconto',
        icon: <FaPercentage />,
        label: 'Redutores e Descontos',
        visible: () =>
          AuthStorage.temCaracteristicas([448]) ||
          AuthStorage.temCaracteristicas([239]) ||
          AuthStorage.temCaracteristicas([630]),
      },
      {
        href: '/comercial/intencoes-vendas',
        icon: <FaSearchDollar />,
        label: 'Intenções de Vendas',
      },
      {
        href: '/comercial/documentos-venda',
        icon: <FaFileAlt />,
        label: 'Documentos de Venda',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP);
        },
      },
      {
        // W-0556 — Estorno de efetivacao reaproveita o menu existente.
        href: '/proposta/estorno/solicitacoes',
        icon: <img src={declined} alt="Estorno de proposta" />,
        label: 'Estorno de proposta',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([277]);
        },
      },
      {
        href: '/imob/cancelamento-mista',
        icon: <img src={proposalCancel} alt="Cancelar Proposta Mista" />,
        label: 'Cancelar Proposta Mista',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CANCELA_PROPOSTA_MISTA),
      },
      {
        // W-0763 — Proposta Rápida. Char 178 ('Proposta Rapida') + char 630 (gate de migração).
        href: '/relatorios/comercial/proposta-rapida',
        icon: <FaListAlt />,
        label: 'Proposta Rápida',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristicas([CARACTERISTICA_HOMOLOGADOR, 178]),
      },
      { divider: true },
      { header: 'Contábil' },
      {
        href: '/imob/contabil/ata-contabil',
        icon: <FaFilePdf />,
        label: 'Ata Contábil',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_ATA_CONTABIL),
      },
      {
        // W-0775 — Baixa de Título (Imob > Contábil). Sem RBAC funcional no ERP (sem char);
        // gate só por char 630 (MigracaoERP) — portão de migração HML, NÃO é RBAC (LICOES §1.8).
        href: '/relatorios/contabil/baixa-titulo',
        icon: <FaFileInvoiceDollar />,
        label: 'Baixa de Título',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        href: '/imob/monitora',
        icon: <FaSearch />,
        label: 'Monitoramento de Clientes',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_MONITORAMENTO),
      },
      {
        // W-0697 — Imóveis Alugados (Imob > Administração). Read-only, gate char 630 (portão migração).
        href: '/imob/imoveis-alugados',
        icon: <FaBuilding />,
        label: 'Imóveis Alugados',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        href: '/imob/comercial/gerenciamento-email',
        icon: <FaEnvelope />,
        label: 'Gerenciamento de E-mail',
        visible: () =>
          !!AuthStorage && AuthStorage.temCaracteristica(MENU_GERENCIA_EMAIL),
      },
      {
        href: '/financeiro/estorno-reapr-cheque',
        icon: <FaMoneyBill />,
        label: 'Estorno de Reapresentação de Cheques',
      },
      {
        href: '/ges/reapresentacao-cheques',
        icon: <FaMoneyBill />,
        label: 'Reapresentação de Cheques',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([CARAC_REAPRESENTAR_CHEQUES]),
      },
      {
        href: ROUTE_ESTORNO_BAIXA_TITULO,
        icon: <FaMoneyBill />,
        label: 'Estorno de baixa de títulos',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([CARACTERISTICA_ESTORNO_TITULO]),
      },
      {
        href: '/inadimplencia',
        icon: <img src={handingMoney} alt="Inadimplência" />,
        label: 'Inadimplência',
      },
      {
        href: '/atualizar-vencimento-titulo',
        icon: <FaCalendarTimes />,
        label: 'Atualizar Vencimento de Título',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
              AuthStorage.temCaracteristica(caracteristicas.ManutencaoTitulo),
      },
      {
        // W-0805 — Re-Financiamentos em Inadimplência (RN-14: sem RBAC próprio;
        // char 630 = portão de migração HML, ortogonal a RBAC — remover no HML→DONE).
        href: '/relatorios/cobranca/refinanciamentos-inadimplencia',
        icon: <FaBarcode />,
        label: 'Re-Financiamentos em Inadimplência',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        href: '/atendimento/controle-taxa-transferencia',
        icon: <FaExchangeAlt />,
        label: 'Controle Taxa Transferência',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      { divider: true },
      {
        header: 'Cobrador',
        visible: () =>
          AuthStorage && AuthStorage.temCaracteristica(COBRANCA_IMOVEL),
      },
      {
        href: '/imob/cobrador/cobranca-sms',
        icon: <FaSms />,
        label: 'Cobrança SMS',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
              AuthStorage.temCaracteristica(caracteristicas.EnvioSmsJuridico),
      },
      {
        href: '/imob/juridico/envio-sms',
        icon: <FaSms />,
        label: 'Envio de SMS (Jurídico)',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
              AuthStorage.temCaracteristica(caracteristicas.CobrancaImovel),
      },
      {
        // W-0827 — Consulta Acordo Judicial. Gate de migração char 630 (MigracaoERP).
        // RBAC 95/125/126 é server-side (backend nega/escopa o combo de cobradores).
        href: '/cobrador/acordo-judicial',
        icon: <FaBalanceScale />,
        label: 'Consulta Acordo Judicial',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        // W-0797 — Imob > Cobrança > Posição Cobrança (read-only). Backend enforça char 86
        // (COBRANCA_IMOVEL) + deriva sojuris/pezao. Menu gateia pelo char 86 (grupo Cobrador)
        // + char 630 (MigracaoERP, portão de migração HML — remover na promoção HML→DONE).
        href: '/imob/cobranca/posicao-cobranca',
        icon: <FaSearchDollar />,
        label: 'Posição Cobrança',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(COBRANCA_IMOVEL) &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        href: '/imob/isencoes-cobranca',
        icon: <FaBarcode />,
        label: 'Isenções de Cobrança',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(COBRANCA_IMOVEL) &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        href: ROUTE_TRANSF_COBRANCA,
        icon: <FaExchangeAlt />,
        label: 'Transferir Títulos para Cobrança',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          (AuthStorage.temCaracteristica(CARACTERISTICA_COBRADOR_GERENCIAL) ||
            AuthStorage.temCaracteristica(CARACTERISTICA_COBRADOR_OPERACIONAL)),
      },
      {
        // W-0829 — Resultado de Atendimento (CRUD Tipo + SubTipo). Característica 291.
        href: ROUTE_RESULTADO_ATENDIMENTO,
        icon: <FaClipboardList />,
        label: 'Resultado de Atendimento',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(RBAC_RESULTADO_ATENDIMENTO),
      },
      {
        href: '/rastreamento-titulos',
        icon: <FaRoute />,
        label: 'Rastreamento de Títulos',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
              AuthStorage.temCaracteristica(
                CARACTERISTICA_RASTREAMENTO_TITULOS
              ),
      },
      {
        // W-0533 — Manutenção de Títulos (char 630 portão migração HML — LICOES §1.8)
        href: '/ges/manutencao-titulos',
        icon: <FaEdit />,
        label: 'Manutenção de Títulos',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
              AuthStorage.temCaracteristica(CARACTERISTICA_MANUTENCAO_TITULO),
      },
      {
        // W-0624 — Perfil de Carteira por Faixa
        href: '/gerencial/carteira/perfil-faixa',
        icon: <FaChartPie />,
        label: 'Perfil de Carteira por Faixa',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        // W-0626 — GES > Gerencial > Relatórios > Carteira > Demonstrativo Financeiro.
        // Gate: char 630 (portão de migração HML) + char 705 (Relat Demonst Financeiro, dedicada).
        href: '/relatorios/carteira/demonstrativo-financeiro',
        icon: <FaCoins />,
        label: 'Demonstrativo Financeiro',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
                AuthStorage.temCaracteristica(
                  caracteristicas.RelatDemonstrativoFinanceiro
                );
        },
      },
      {
        href: '/ges/negocios/titulos/baixa-por-data',
        icon: <FaCoins />,
        label: 'Baixa Título por Data',
        // W-0551 — Char 630 (caracteristicas.MigracaoERP) é portão obrigatório durante HML
        // (LICOES §1.8) — manter no OR menu+rota até promoção HML→DONE. BE checa
        // PossuiCaracteristicaPorId(635) (granular único) em BaixaTituloController.cs.
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
              AuthStorage.temCaracteristica(CARACTERISTICA_BAIXA_TITULO),
      },
      {
        // W-0554 — Correção de Títulos a Pagar — char 630 portão de migração (LICOES §1.8)
        href: '/ges/negocios/titulos/correcao',
        icon: <FaCoins />,
        label: 'Correção de Títulos a Pagar',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      {
        href: '/ges/simulacao-proposta',
        icon: <FaCalculator />,
        label: 'Simulação de Propostas',
      },
      {
        href: '/procuracoes',
        icon: <FaGavel />,
        label: 'Procurações',
        visible: () => {
          return !AuthStorage ? false : AuthStorage.temCaracteristicas([627]);
        },
      },
      { divider: true },
      { header: 'Documento Digital' },
      {
        href: '/documentoDigital/lancamento',
        icon: (
          <img src={proposalAccept} alt="Consultar documentos de clientes" />
        ),
        label: 'Gerecial Assinatura',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([
                caracteristicas.ManutencaoDocDigital,
              ]);
        },
      },
      {
        href: '/documentoDigital/controle',
        icon: <img src={proposalAccept} alt="Consultar documentos digitais" />,
        label: 'Controle',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([
                caracteristicas.ConsultaDocDigital,
              ]);
        },
      },
      {
        href: '/juridico/controle-contrato',
        icon: <FaFileAlt />,
        label: 'Controle de Contrato',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.ControleContrato) &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        divider: true,
      },
      {
        header: 'Proposta',
      },
      {
        href: '/vendas/autorizacao',
        icon: <img src={proposalReject} alt="Autorizar Venda v2" />,
        label: 'Autorizar Venda',
      },
      {
        href: `${URLV1}/Propostas/PrevendaSemConjuge.aspx`,
        icon: (
          <img src={proposalCancel} alt="Venda sem assinatura do cônjuge" />
        ),
        label: 'Pré-Venda sem cônjuge',
        visible: () => {
          return !AuthStorage ? false : AuthStorage.temCaracteristicas([242]);
        },
      },
      {
        divider: true,
      },
      {
        header: 'PDV',
      },

      {
        href: '/comercial/pdv',
        icon: <FaEdit />,
        label: 'Cadastro de PDV',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        href: `/vendas/controle-pdv`,
        icon: <FaSitemap />,
        label: 'Controle do PDV',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([279, 295, 347]);
        },
      },

      {
        href: `${URLV1}/PDV/Fechamento.aspx`,
        icon: <FaBarcode />,
        label: 'Fechamento',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([278, 296, 348]);
        },
      },
      {
        href: `/parametrospdv`,
        icon: <FaCog />,
        label: 'Parâmetros',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicaGerParametros();
        },
      },
      {
        href: `/parametrospdv/integracao`,
        icon: <FaCog />,
        label: 'Integração',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([347, 279, 295, 605]);
        },
      },
    ],
    visible: () => {
      return (
        AuthStorage &&
        AuthStorage.temCaracteristicas(
          [],
          [495, 501, CARACTERISTICA_CHECKIN_PESQUISA_EVENTO]
        ) &&
        !AuthStorage.isAtendenteLancamento() &&
        !AuthStorage.temCaracteristica(584)
      );
    },
  },
  {
    icon: <FaGavel />,
    label: 'Jurídico',
    dropdown: [
      {
        header: 'Controle PJ',
      },
      {
        href: '/juridico/horas-pj/prestadores',
        icon: <FaBriefcase />,
        label: 'Prestadores',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTROLE_HORAS_PJ),
      },
      {
        href: '/juridico/horas-pj/contratos',
        icon: <FaFileAlt />,
        label: 'Contratos',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTROLE_HORAS_PJ),
      },
      {
        href: '/juridico/horas-pj/fechamento',
        icon: <FaCalendarAlt />,
        label: 'Fechamento',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTROLE_HORAS_PJ),
      },
      {
        href: '/juridico/horas-pj/fundos',
        icon: <FaCoins />,
        label: 'Fundos',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTROLE_HORAS_PJ),
      },
      {
        href: '/juridico/horas-pj/rescisao',
        icon: <FaCalculator />,
        label: 'Rescisão',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTROLE_HORAS_PJ),
      },
      {
        href: '/juridico/horas-pj/relatorios',
        icon: <FaChartBar />,
        label: 'Relatórios',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTROLE_HORAS_PJ),
      },
      {header: 'Solicitações'},
      {
        href: '/juridico/solicitacoes',
        icon: <FaBalanceScale />,
        label: 'Solicitações',
      }
    ],
    visible: () =>
      AuthStorage &&
      AuthStorage.temCaracteristica(CARACTERISTICA_CONTROLE_HORAS_PJ),
  },

  {
    icon: <FaChartBar />,
    label: 'Relatórios',
    href: '/comercial/relatorios',
    visible: () => {
      return (
        AuthStorage &&
        AuthStorage.temCaracteristicas(
          [],
          [495, 501, CARACTERISTICA_CHECKIN_PESQUISA_EVENTO]
        ) &&
        !AuthStorage.isAtendenteLancamento() &&
        !AuthStorage.temCaracteristica(584)
      );
    },
  },
  {
    icon: <FaGlobe />,
    label: 'Sismac',
    href: `/sismac/ficha-empreendimentos/`,
    visible: () => {
      return (
        AuthStorage &&
        !AuthStorage.isAtendenteLancamento() &&
        !AuthStorage.temCaracteristica(584) &&
        !AuthStorage.temCaracteristica(CARACTERISTICA_CHECKIN_PESQUISA_EVENTO)
      );
    },
  },
  {
    icon: <FaUser />,
    label: 'Usuários',
    dropdown: [
      {
        href: '/usuarios',
        icon: <FaUser />,
        label: 'Cadastro',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([
                caracteristicas.ManutencaoUsuario,
                caracteristicas.VisualizaUsuarioCorretor,
                caracteristicas.SomenteConsultaUsuarios,
              ]);
        },
      },
      {
        href: '/usuarios/grupos',
        icon: <FaUsers />,
        label: 'Grupos',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.temCaracteristica(
                  caracteristicas.ManutencaoUsuario
                );
        },
      },
      {
        href: '/usuarios/caracteristicas',
        icon: <FaCogs />,
        label: 'Características',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.ManutencaoUsuario);
        },
      },
      {
        href: '/usuarios/portador',
        icon: <FaExchangeAlt />,
        label: 'Portador',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([615]);
        },
      },
      {
        href: '/negocios/remanejamento-caixa',
        icon: <FaExchangeAlt />,
        label: 'Remanejamento de Caixas',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.temCaracteristicas([475]);
        },
      },
      {
        href: '/usuarios/hierarquia',
        icon: <FaSitemap />,
        label: 'Hierarquia Comercial',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([619], [495]) 
        },
      },
      { divider: true },
      { header: 'Ferramentas' },
      {
        href: '/ferramentas/validador-assinatura-digital',
        icon: <FaLock />,
        label: 'Validador Assinatura Digital',
        visible: () => {
          return AuthStorage
            ? AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.temCaracteristica(
                  CARACTERISTICA_VALIDADOR_ASSINATURA_DIGITAL
                )
            : false;
        },
      },
      {
        href: '/ferramentas/grupo-empresa',
        icon: <FaBuilding />,
        label: 'Grupo de Empresas',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas(
                [caracteristicas.AlteraStatusGE],
                [caracteristicas.AlteraStatusGE2]
              ) && AuthStorage.temCaracteristica(caracteristicas.MigracaoERP);
        },
      },
      {
        href: '/ferramentas/cadastro-unico-fornecedor',
        icon: <FaUserTie />,
        label: 'Cadastro Único Fornecedores',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP);
        },
      },
      {
        href: '/contas',
        icon: <FaCog />,
        label: 'Manutenção de Contas',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
          );
        },
      },
      {
        // W-0547 - Importação XLS de Contas. Acesso exige homologador 630 e característica granular 641.
        href: '/ges/contas/manutencao/importacao-xls-contas',
        icon: <FaFileExcel />,
        label: 'Importação XLS Contas',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
              AuthStorage.temCaracteristica(
                CARACTERISTICA_IMPORTACAO_XLS_CONTAS
              ),
      },
      {
        // W-0539 — Contas Prefeitura Sem Convênio. Delphi não tinha RBAC
        // (uContaPrefeituraSemConvenio.pas + ProjetoMAIN.PAS:4366-4372 sem AutorizaUsuario).
        // Durante HML usa apenas char 630 (LICOES §1.8). Ao promover HML→DONE, decidir se
        // cria granular dedicada (recomendado para operação destrutiva) ou abre para todos.
        href: ROUTE_CONTAS_PREFEITURA_SEM_CONVENIO,
        icon: <FaCog />,
        label: 'Contas Prefeitura Sem Convênio',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        href: '/ferramentas/contas-salario',
        icon: <FaMoneyBill />,
        label: 'Contas de Salário',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.temCaracteristicas([caracteristicas.AcessoSalario]);
        },
      },
      {
        href: '/ferramentas/digitalizacao',
        icon: <FaFilePdf />,
        label: 'Digitalização',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.MigracaoERP);
        },
      },
      {
        // W-0490 — Transferência de Ocorrências (GES > Ferramentas) — char 630 portão de migração (LICOES §1.8)
        href: ROUTE_TRANSFERENCIA_OCORRENCIAS,
        icon: <FaExchangeAlt />,
        label: 'Transferência de Ocorrências',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.temCaracteristica(
                  CARACTERISTICA_TRANSFERENCIA_OCORRENCIAS
                );
        },
      },
      {
        href: ROUTE_PARAMETROS_SISTEMA_FUSAO,
        icon: <FaCog />,
        label: 'Parâmetros do Sistema — Fusão',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.temCaracteristica(caracteristicas.Sis_parametros);
        },
      },
      {
        // W-0657 — Lista de E-mail de Clientes. Sem RBAC funcional; char 630 é portão de migração.
        href: ROUTE_LISTA_EMAIL_CLIENTES,
        icon: <FaEnvelope />,
        label: 'Lista de E-mail de Clientes',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      { divider: true },
      { header: 'Auditoria' },
      {
        href: '/auditoria/log-atualizacoes',
        icon: <FaHistory />,
        label: 'Log de Atualizações',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([caracteristicas.LogAtualizacoes]);
        },
      },
      {
        // W-0928 — OR [630, 660]: char 630 portão de migração (obrigatório durante HML; LICOES §1.8)
        // + char 660 funcional (CARACTERISTICA_RELAT_CONTAS_SEM_SALDO_CONF). Manter os dois até
        // promoção HML→DONE. BE também checa AND [630, 660] no controller.
        href: '/relatorios/audit/contas-sem-saldo-conferido',
        icon: <FaSearchDollar />,
        label: 'Contas sem saldo conferido',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.temCaracteristica(
                  CARACTERISTICA_RELAT_CONTAS_SEM_SALDO_CONF
                );
        },
      },
      {
        // W-0935 — [100, 630] = char Auditoria + portão de migração (LICOES §1.8).
        // Remover 630 na promoção HML→DONE com liberação geral.
        href: ROUTE_CHEQUES_PRORROGADOS,
        icon: <FaSearchDollar />,
        label: 'Cheques Prorrogados',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
                AuthStorage.temCaracteristica(CARACTERISTICA_AUDITORIA);
        },
      },
      {
        // W-0937 — [100, 630] = char Auditoria + portão de migração (LICOES §1.8).
        // Remover 630 na promoção HML→DONE com liberação geral.
        href: ROUTE_HISTORICO_IMOVEIS,
        icon: <FaSearchDollar />,
        label: 'Histórico de Imóveis',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_AUDITORIA) &&
              AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR);
        },
      },
      {
        href: '/relatorios/contratos/com-construcao',
        icon: <FaSearchDollar />,
        label: 'Contratos com Construção',
        visible: () => {
          return !AuthStorage ? false : AuthStorage.temCaracteristicas([605]);
        },
      },
    ],
    visible: () => {
      return (
        AuthStorage &&
        !AuthStorage.isAtendenteLancamento() &&
        !AuthStorage.temCaracteristica(584)
      );
    },
  },
  {
    icon: <FaCogs />,
    label: 'Configurações',
    dropdown: [
      {
        header: 'Gerencial',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([], [495]);
        },
      },

      {
        // W-0611 — Saldo de Conta Banco (gate 630)
        href: '/ges/gerencial/financas/saldo-conta-banco',
        icon: <FaUniversity />,
        label: 'Saldo de Conta Banco',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      {
        // W-0612 — Fluxo de Caixa Gerencial (gate 630 + característica 152)
        href: '/ges/gerencial/financas/fluxo-caixa',
        icon: <FaChartBar />,
        label: 'Fluxo de Caixa',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
              AuthStorage.temCaracteristica(CARACTERISTICA_RATEIO_TEMPLATE),
      },
      {
        // W-0613 — Posição Sintética Carteira a Receber (gate 630 + característica 692)
        href: '/ges/gerencial/financas/posicao-sintetica-carteira-receber',
        icon: <FaChartBar />,
        label: 'Posição Sintética Carteira a Receber',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
              AuthStorage.temCaracteristica(
                CARACTERISTICA_POSICAO_SINTETICA_CARTEIRA_RECEBER
              ),
      },
      {
        // W-0617 — Mapeamento Geral Estoque. Sem RBAC: o ERP não controla acesso a esta
        // tela (gate-1a / lesson W-0509) — sem visible() por característica.
        href: '/ges/gerencial/estoque/mapeamento-geral-estoque',
        icon: <FaCubes />,
        label: 'Mapeamento Geral Estoque',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      {
        // TEMP W-0564 ADR-001 — reavaliar granularidade
        href: '/rateio-template',
        icon: <FaListAlt />,
        label: 'Templates de Rateio',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
              AuthStorage.temCaracteristica(CARACTERISTICA_RATEIO_TEMPLATE),
      },
      {
        // W-0634 — Manual de Apuração de Resultados (leitura aberta; edição usa char 630 na página)
        href: ROUTE_MANUAL_APURACAO,
        icon: <FaFileAlt />,
        label: 'Manual de Apuração',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      {
        href: `/indicacao`,
        icon: <FaRocket />,
        label: 'Indicação',
        visible: () => {
          return !AuthStorage ? false : AuthStorage.temCaracteristicas([582]);
        },
      },
      {
        href: `/roleta/leads`,
        icon: <FaMarker />,
        label: 'Escalas',
        visible: () => {
          return !AuthStorage ? false : AuthStorage.temCaracteristicas([577]);
        },
      },
      {
        href: `/tagsatendimento`,
        icon: <FaEdit />,
        label: 'Tags de atendimento',
        visible: () => {
          // rever quem pode ver
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(caracteristicas.AtendenteCav);
        },
      },
      {
        href: '/configuracoes/campanhas',
        icon: <FaRocket />,
        label: 'Campanhas',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicaGerParametros();
        },
      },
      {
        href: '/relatorios/despesa-depto',
        icon: <FaChartPie />,
        label: 'Despesa por Departamento',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([
                caracteristicas.RelDespesaDepto,
              ]) && AuthStorage.temCaracteristica(caracteristicas.MigracaoERP);
        },
      },
      {
        // W-0600 — Relatório de Digitalizações (read-only). Gate por isADM (ADR-002), sem característica.
        href: '/relatorios/digitalizacoes',
        icon: <FaClipboardList />,
        label: 'Relatório de Digitalizações',
        visible: () =>
          !AuthStorage
            ? false
            : AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
              AuthStorage.isADM(),
      },
      {
        href: '/financeiro/relatorios/despesas-analitico',
        icon: <FaSearchDollar />,
        label: 'Analítico de Despesas',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristicas([
              caracteristicas.RelDespesasAnalitico,
            ]) &&
            AuthStorage.temCaracteristicas([caracteristicas.MigracaoERP])
          );
        },
      },
      {
        // W-0840 — Pro-Fit > Relatórios > Comissão de Imóveis (char 630 portão de migração + char 652 dedicada)
        href: '/relatorios/comissao-imoveis',
        icon: <FaFileAlt />,
        label: 'Comissão de Imóveis',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_RELAT_COMISSAO_IMOVEIS),
      },
      {
        divider: true,
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([], [495]);
        },
      },
      {
        header: 'Sistema',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicas([], [495]);
        },
      },
      {
        href: `/lancamento/treinamento`,
        icon: <FaInfoCircle />,
        label: 'Treinamento',
        // visible: () => {
        //   return !AuthStorage ? false : AuthStorage.temCaracteristicas([]);
        // },
      },
      { divider: true },
      { header: 'Atendimento' },
      {
        href: '/atendimento/debitos-municipais',
        icon: <FaClipboardList />,
        label: 'Débitos Municipais',
        visible: () => {
          return !AuthStorage ? false : AuthStorage.temCaracteristicas([372]);
        },
      },
      { divider: true },
      { header: 'Parâmetros' },
      {
        href: '/configuracoes/prospecto/fluxo',
        icon: <img src={sistema} alt="Fluxo Prospecto" />,
        label: 'Fluxo do prospecto',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicaGerParametros([495]);
        },
      },
      {
        href: '/configuracoes/campanha',
        icon: <FaRocket />,
        label: 'Ranking de Campanha',
        visible: () => {
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicaGerParametros();
        },
      },
      {
        href: '/configuracoes/renegociacao',
        icon: <FaCogs />,
        label: 'Parâmetros de Renegociação',
        visible: () => {
          if (isAmbienteProducao()) return false;
          return !AuthStorage
            ? false
            : AuthStorage.temCaracteristicaParametrosRenegociacao();
        },
      },
      {
        // DW-0999 — Contatos de Teste (e-mail e telefone usados em testes de envio). Char 725.
        href: ROUTE_PARAMETROS_CONTATOS_TESTE,
        icon: <FaCog />,
        label: 'Contatos de teste',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTATOS_TESTE),
      },
      { divider: true },
      { header: 'Negócio' },
      {
        href: '/configuracoes/categoria-departamento',
        icon: <FaListAlt />,
        label: 'Categoria de Departamento',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
            AuthStorage.temCaracteristicas([629])
          );
        },
      },
      {
        href: '/configuracoes/tabelas/ramos_atividade',
        icon: <FaBriefcase />,
        label: 'Ramos de Atividade',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        href: '/ges/contas/tabelas/tipo-conta-interna',
        icon: <FaListAlt />,
        label: 'Tipos de Conta Interna',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(
            caracteristicas.ManutencaoTipoContaInterna
          ),
      },
      {
        // W-0543 — Contas de Difícil Liquidação. Char 630 portão de migração (LICOES §1.8) — remover na promoção.
        href: ROUTE_CONTAS_DIF_LIQ,
        icon: <FaListAlt />,
        label: 'Contas de Difícil Liquidação',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTAS_DIF_LIQ),
      },
      {
        href: '/ges/cartoes',
        icon: <FaCreditCard />,
        label: 'Cadastro de Cartões',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CADASTRO_CARTAO_TAXA),
      },
      {
        // W-0540 — Saldos de Contas. Char 630 portão de migração (LICOES §1.8) — remover na promoção.
        // AND duplo: temCaracteristicas([...]) é OR — usar temCaracteristica singular em série.
        href: ROUTE_SALDOS_CONTAS,
        icon: <FaSearchDollar />,
        label: 'Saldos de Contas',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CHAR_SALDO_CONTAS_CONFERIR),
      },
      {
        href: '/configuracoes/historico-padrao',
        icon: <FaListAlt />,
        label: 'Histórico Padrão',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        href: '/financeiro/contas-intercambio',
        icon: <FaExchangeAlt />,
        label: 'Contas de Intercâmbio',
        visible: () => AuthStorage && AuthStorage.temCaracteristicas([261]),
      },
      {
        href: '/configuracoes/tabelas/alinea',
        icon: <FaTicketAlt />,
        label: 'Alíneas',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      {
        href: '/configuracoes/tabelas/categorias',
        icon: <FaListAlt />,
        label: 'Categorias de Contas',
        visible: () => AuthStorage && AuthStorage.temCaracteristicas([630]),
      },
      {
        href: '/negocios/departamentos',
        icon: <FaSitemap />,
        label: 'Departamentos',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
            AuthStorage.temCaracteristicas([261])
          );
        },
      },
      {
        href: '/cadastros/parcerias',
        icon: <FaHandshake />,
        label: 'Parcerias',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
            AuthStorage.temCaracteristicas([235])
          );
        },
      },
      {
        href: '/negocios/centro-de-custo',
        icon: <FaCoins />,
        label: 'Centro de Custo',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([573]),
      },
      {
        href: '/negocios/tabelas/feriados',
        label: 'Feriados',
        icon: <FaCalendarAlt />,
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        href: '/configuracoes/paises',
        icon: <FaGlobe />,
        label: 'Países',
        visible: () => {
          AuthStorage &&
            AuthStorage.temCaracteristica(caracteristicas.MigracaoERP);
        },
      },
      {
        href: '/cotacoes',
        icon: <FaExchangeAlt />,
        label: 'Cotações',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
            AuthStorage.temCaracteristicas([48])
          );
        },
      },
      {
        href: ROUTE_EXP_IMP_COTACAO_MOEDA_FORTE,
        icon: <FaFileAlt />,
        label: 'Exp/Imp Cotação Moeda Forte',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristicas([CARACT_EXP_IMP_COTACAO_MOEDA_FORTE]),
      },
      {
        // W-0652: característica 35 (AtualizaAtivo) — char 630 (HOMOLOGADOR) é gate de migração no PrivateRoute
        href: ROUTE_ALTERA_NOME_ATIVO,
        icon: <FaEdit />,
        label: 'Altera Nome Ativo',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.AtualizaAtivo),
      },
      {
        // W-0663 — Acerta contas de despesas/receitas (gate transitório [630, 645] — Setpar §1.8)
        href: ROUTE_ACERTAR_CONTA,
        icon: <FaExchangeAlt />,
        label: 'Acerta Contas Despesa/Receita',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_ACERTAR_CONTA),
      },
      {
        // W-0651 — Altera Código Conta (AND: 630 visibilidade HML + 31 funcional)
        href: ROUTE_ALTERAR_CODIGO_CONTA,
        icon: <FaExchangeAlt />,
        label: 'Altera Código Conta',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_ALTERAR_CODIGO_CONTA),
      },
      {
        // W-0654 — Altera Código Departamento (AND: 630 visibilidade HML + 677 funcional)
        href: ROUTE_ALTERAR_CODIGO_DEPARTAMENTO,
        icon: <FaExchangeAlt />,
        label: 'Altera Código Departamento',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(
            CARACTERISTICA_ALTERAR_CODIGO_DEPARTAMENTO
          ),
      },
      {
        // W-0664 — Fechamento de Caixa (GES > Ferramentas) — char 191 + char 630 (gate UAT)
        href: ROUTE_FECHAMENTO_CAIXA,
        icon: <FaCoins />,
        label: 'Fechamento de Caixa',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_FECHA_CAIXA),
      },
      {
        href: '/configuracoes/tabelas/contas-usuario',
        icon: <FaUsers />,
        label: 'Contas de Usuário',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        // W-0541: Contas bloqueadas no extrato — char 630 portão de migração
        href: '/ges/contas-bloqueadas-extrato',
        icon: <FaLock />,
        label: 'Contas bloqueadas no extrato',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
          AuthStorage.temCaracteristica(caracteristicas.LiberaExtrato),
      },
      {
        href: '/imob/atendimento/tipo-atendimento',
        icon: <FaListAlt />,
        label: 'Tipo de Atendimento',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(TIPO_ATENDIMENTO_CARACTERISTICA) &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        href: '/cadastros/cidades',
        icon: <FaGlobe />,
        label: 'Cidades',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristicas([
              caracteristicas.ManutencaoCidades,
            ]) &&
            AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
          );
        },
      },
      {
        href: '/cartao-credito',
        icon: <FaCreditCard />,
        label: 'Cadastro de Cartão de Crédito',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CARTAO_CREDITO),
      },
      {
        href: '/cadastros/imobiliarias',
        icon: <FaBuilding />,
        label: 'Imobiliárias',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristicas([
            caracteristicas.CadastraImobiliaria,
          ]),
      },
      {
        href: '/negocios/despesa-cartao-credito',
        icon: <FaMoneyBill />,
        label: 'Despesa de Cartão de Crédito',
        visible: () =>
          !!AuthStorage.getUser() &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        // W-0526 — GES > Negócios > Autoriza Despesa/Projetos — char 630 AND (165|265|259|258) em HML (PRD §3).
        href: ROUTE_AUTORIZA_DESPESA,
        icon: <FaMoneyBill />,
        label: 'Autoriza Despesa/Projetos',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas(CARACTERISTICAS_APROVACAO_DESPESA),
      },
      {
        href: '/negocios/fechamento-cartao-credito',
        icon: <FaBarcode />,
        label: 'Fechamento Despesa de Cartão',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        href: '/ges/relatorios/cidades-por-regiao',
        icon: <FaFileAlt />,
        label: 'Cidades por Região',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristicas([
              caracteristicas.ManutencaoCidades,
            ]) &&
            AuthStorage.temCaracteristicas([caracteristicas.MigracaoERP])
          );
        },
      },
      {
        href: '/relatorios/ges/contas/ramo',
        icon: <FaFileAlt />,
        label: 'Ramos de Atividade (Relatório)',
        visible: () => {
          return AuthStorage && AuthStorage.temCaracteristicas([630]);
        },
      },
      {
        // W-0593 — Relatório de Centro de Custo — char 630 portão de migração
        href: '/ges/relatorios/contas/centro-custo',
        icon: <FaFileAlt />,
        label: 'Centro de Custo (Relatório)',
        visible: () => AuthStorage && AuthStorage.temCaracteristicas([630]),
      },
      {
        // W-0595 — Lista de Negócios — par char 630 (migração) + char 83 (acesso Negócio);
        // espelha RelNegociosController.TemAcesso() (AND, não OR).
        href: '/ges/relatorios/negocios/lista',
        icon: <FaFileAlt />,
        label: 'Lista de Negócios (Relatório)',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(630) &&
          AuthStorage.temCaracteristica(83),
      },
      {
        // W-0627 — Relatório Carteira por Conta Capital — char 630 portão de migração
        href: '/ges/relatorios/carteira/conta-capital',
        icon: <FaFileAlt />,
        label: 'Carteira por Conta Capital (Relatório)',
        visible: () => AuthStorage && AuthStorage.temCaracteristicas([630]),
      },
      {
        // W-0607 — Consulta de Aniversariantes (read-only) — gate AND char 630 (migração)
        // + char 647 (LGPD); espelha AniversariantesController.PossuiPermissao(). Oculto
        // até o DBA cadastrar a char 647 (comportamento esperado).
        href: ROUTE_CONSULTA_ANIVERSARIANTES,
        icon: <FaSearch />,
        label: 'Consulta de Aniversariantes',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(
            CARACTERISTICA_CONSULTA_ANIVERSARIANTES
          ),
      },
      {
        // W-0604 — GES Etiquetas/Cartas (emissão em lote). Produção confirmada em 2026-07-27.
        // VALUE-GATE: mantém char 236 (Relatório Dados Cliente).
        href: ROUTE_ETIQUETAS_CARTAS,
        icon: <FaFileAlt />,
        label: 'Etiquetas / Cartas',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_RELATORIO_CONTAS),
      },
      {
        // W-0579 — Sem permissão por característica (ADR-002): qualquer usuário autenticado
        href: '/ges/relatorios/titulos/cheques-devolvidos',
        icon: <FaFileAlt />,
        label: 'Cheques Devolvidos',
        visible: () =>
          !!AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      {
        href: ROUTE_RELATORIO_PLANO_CONTAS,
        icon: <FaFileAlt />,
        label: 'Plano de Contas',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        href: ROUTE_HISTORICO_PADRAO,
        icon: <FaFileAlt />,
        label: 'Histórico Padrão',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      {
        href: '/relatorios/familias-ativos',
        icon: <FaFileAlt />,
        label: 'Famílias de Ativos',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
            AuthStorage.temCaracteristicas([
              caracteristicas.CriarAlterarFamilia,
            ])
          );
        },
      },
      {
        href: '/relatorios/contas-saldo-disponivel',
        icon: <FaFileAlt />,
        label: 'Contas Saldo Disponível',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(8) &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        // W-0530: relatório público dentro de [Authorize] base — ADR-001 (sem segunda característica)
        href: '/relatorios/qualidades-ativos',
        icon: <FaFileAlt />,
        label: 'Qualidade de Ativos',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        // W-0584: Ativo por Família — [AuthorizeUser] base, gate char 630 (portão migração)
        href: '/relatorios/ativo-familia',
        icon: <FaFileAlt />,
        label: 'Ativo por Família',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP),
      },
      {
        // W-0787: Análise Empreendimento — acesso livre (login), fiel ao ERP (lesson W-0509)
        href: '/relatorios/analise-empreendimento',
        icon: <FaFileAlt />,
        label: 'Análise Empreendimento',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
      {
        // W-0583: característica 35 (AtualizaAtivos) — ADR-001
        href: '/relatorios/lista-ativos',
        icon: <FaFileAlt />,
        label: 'Lista de Ativos',
        visible: () => AuthStorage && AuthStorage.temCaracteristicas([630]),
      },
      {
        href: '/configuracoes/tabelas/regioes',
        icon: <FaMapMarkedAlt />,
        label: 'Regiões',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
          AuthStorage.temCaracteristicas([261]),
      },
      {
        href: '/relatorios/contas',
        icon: <FaFileAlt />,
        label: 'Relatório de Contas',
        visible: () => AuthStorage && AuthStorage.temCaracteristica(630),
      },
      {
        href: '/negocios/despesa-tipo-pagamento',
        icon: <FaExchangeAlt />,
        label: 'Vínculo Despesa x Tipo Pgto',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
            AuthStorage.temCaracteristicas([573])
          );
        },
      },
      {
        href: '/negocios/centro-de-custo',
        icon: <FaCoins />,
        label: 'Centro de Custo',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([573]),
      },
      {
        href: '/matricial-despesas/usuario-alternativo',
        icon: <FaUserTie />,
        label: 'Usuário Alternativo (Matricial)',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
            AuthStorage.temCaracteristicas([261])
          );
        },
      },
      {
        href: '/matricial-despesas/periodos',
        icon: <FaCalendarAlt />,
        label: 'Períodos (Matricial)',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(260) &&
          AuthStorage.temCaracteristica(630),
      },
      {
        href: '/ges/aprovacao-pagamentos',
        icon: <FaMoneyBill />,
        label: 'Aprovação de Pagamentos',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas(CARACTERISTICAS_APROVACAO_DESPESA),
      },
      {
        href: '/ges/negocios/nivel-retencao',
        icon: <FaUserTie />,
        label: 'Nível de Retenção',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristicas([CARACTERISTICA_HOMOLOGADOR]),
      },
      { divider: true },
      { header: 'Administração' },
      {
        href: '/administracao/alertas-clientes',
        icon: <FaBell />,
        label: 'Alertas de Clientes',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
            !AuthStorage.isAtendenteLancamento()
          );
        },
      },
      { divider: true },
      { header: 'Segurança' },
      {
        icon: <FaKey />,
        label: 'Consulta Acesso',
        href: '/consulta-acesso',
        visible: () => {
          return (
            AuthStorage &&
            AuthStorage.temCaracteristicas([389, 595, 596, 611, 656])
          );
        },
      },
      {
        icon: <FaCogs />,
        label: 'Painel RMM',
        href: '/painelrmm',
        visible: () => {
          return AuthStorage && AuthStorage.temCaracteristicas([574]);
        },
      },
      {
        href: RETORNO_COBRANCA_BRADESCO,
        icon: <FaFileUpload />,
        label: 'Retorno Bradesco',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_RETORNO_BRADESCO),
      },
      {
        // W-0882 — Retorno Cobrança - Geral (CEF/BRADESCO/TIVIT/SANTANDER)
        // char 630 (CARACTERISTICA_HOMOLOGADOR) é portão de migração — LICOES §1.8/ADR-007
        href: RETORNO_COBRANCA_GERAL,
        icon: <FaFileUpload />,
        label: 'Retorno Cobrança - Geral',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristicas([CARACTERISTICA_HOMOLOGADOR]),
      },
      {
        href: ROUTE_CONCILIACAO_BANCARIA,
        icon: <FaFileUpload />,
        label: 'Conciliação Bancária - Geral',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CONCILIACAO_BANCARIA),
      },
      {
        // W-0872 — Relatório Remessa de Boletos — char 630 portão de migração (LICOES §1.8)
        href: ROUTE_RELATORIO_REMESSA_BOLETOS,
        icon: <FaFileAlt />,
        label: 'Remessa de Boletos (Relatório)',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(
            CARACTERISTICA_RELATORIO_REMESSA_BOLETOS
          ),
      },
      { divider: true },
      { header: 'Generate — Manutenção' },
      {
        // W-0858 — Relacionamento de Contas (ADR-001: char compartilhada 708)
        href: ROUTE_RELACIONAMENTO_CONTAS,
        icon: <FaExchangeAlt />,
        label: 'Relacionamento de Contas',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_GENERATE_MANUTENCAO),
      },
      { divider: true },
      { header: 'Generate — Consulta' },
      {
        // W-0883 — Consulta Protocolo de Remessas (read-only). Sem char próprio
        // (espelha GES); char 630 (CARACTERISTICA_HOMOLOGADOR) portão de migração.
        href: '/generate/protocolo-remessas',
        icon: <FaFileAlt />,
        label: 'Protocolo de Remessas',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR),
      },
    ],
    visible: () => {
      return (
        AuthStorage &&
        AuthStorage.temCaracteristicas(
          [],
          [501, CARACTERISTICA_CHECKIN_PESQUISA_EVENTO]
        ) &&
        !AuthStorage.isAtendenteLancamento() &&
        !AuthStorage.temCaracteristica(584)
      );
    },
  },
  {
    icon: <FaBell />,
    label: 'Marketing',
    dropdown: [
      {
        // DW-0996 — Sistema RSVP Eventos (Admin CRM)
        // ADR-002: característicacost 671 exclusiva marketing
        href: ROUTE_EVENTOS_RSVP,
        icon: <FaCalendarAlt />,
        label: 'Eventos RSVP',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_EVENTO_RSVP),
      },
      {
        // DW-0998 — Check-in de Evento (portaria). Reusa caract. 671.
        href: ROUTE_EVENTO_RSVP_CHECKIN,
        icon: <FaCalendarAlt />,
        label: 'Check-in de Evento',
        visible: () =>
          AuthStorage &&
          (AuthStorage.temCaracteristica(CARACTERISTICA_EVENTO_RSVP) ||
            AuthStorage.temCaracteristica(
              CARACTERISTICA_CHECKIN_PESQUISA_EVENTO
            )),
      },
      {
        // DW-0998 — Pesquisas Entrada/Saída do Evento SetGarden.
        // Gating: isAdm OU característica 671 (RSVP) OU 687 (Checkin/Pesquisa Entrega).
        href: ROUTE_PESQUISA_EVENTO,
        icon: <FaClipboardList />,
        label: 'Pesquisa de Evento',
        visible: () =>
          !!AuthStorage &&
          (AuthStorage.isAdm() ||
            AuthStorage.temCaracteristica(CARACTERISTICA_EVENTO_RSVP) ||
            AuthStorage.temCaracteristica(
              CARACTERISTICA_CHECKIN_PESQUISA_EVENTO
            )),
      },
      {
        // Gerador de Assinatura de E-mail — migração de WebImob2015/Assinatura.aspx.
        // Sem característica: qualquer usuário autenticado acessa.
        href: '/ferramentas/assinatura-email',
        icon: <FaEnvelope />,
        label: 'Gerador de Assinatura de E-mail',
        visible: () => true,
      },
    ],
    // Guia visível para qualquer usuário logado (o Gerador de Assinatura é liberado a todos);
    // os demais itens (RSVP/Eventos) seguem gated individualmente.
    visible: () => {
      return AuthStorage && !AuthStorage.isAtendenteLancamento();
    },
  },
  {
    icon: <FaComments />,
    label: 'Comunicação',
    dropdown: [
      {
        href: '/faq',
        icon: <FaQuestionCircle />,
        label: 'FAQ',
      },
      {
        href: '/solicitacoes',
        icon: <FaClipboardList />,
        label: 'Solicitações',
        visible: () => {
          return (
            AuthStorage &&
            !AuthStorage.isAtendenteLancamento() &&
            !AuthStorage.temCaracteristica(584)
          );
        },
      },
      {
        href: '/comunicacao/comunicado-email',
        icon: <FaEnvelope />,
        label: 'Comunicado Email',
        visible: () =>
          AuthStorage &&
          AuthStorage.temCaracteristicas([CARAC_COMUNICADO_EMAIL]),
      },
    ],
    visible: () => {
      return AuthStorage && !AuthStorage.isAtendenteLancamento();
    },
  },
];

const getLinks = () => {
  if (AuthStorage.isCorretorDesligado()) return [];

  // Lê do LocalStorage (persiste entre reloads) para não depender do timing da variável de módulo
  const user = AuthStorage.getUser();
  const lancamento =
    (user && user.empreendimento_lancamento) || EMPREENDIMENTO_LANCAMENTO;
  const mapaHref = lancamento ? `/mapa/${lancamento}` : '/mapa';

  return links
    .map(link => {
      if (!link.dropdown) return link;

      return {
        ...link,
        dropdown: link.dropdown
          .filter(drop => !drop.visible || (drop.visible && drop.visible()))
          .map(drop => {
            if (
              drop.label === 'Mapa do empreendimento' ||
              drop.label === 'Mapa Humanizado'
            ) {
              return { ...drop, href: mapaHref };
            }
            if (drop.label === 'Mapa do Empreendimento' && lancamento) {
              return {
                ...drop,
                href: `/mapa-empreendimento?familia=${lancamento}`,
              };
            }
            return drop;
          }),
      };
    })
    .filter(link => !link.visible || (link.visible && link.visible()));
};

export default getLinks;
